/* eslint-disable indent */
import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

interface ToggleSwitchProps {
    offbackgroundcolour?: string;
}

export const ToggleSwitch = styled.label<ToggleSwitchProps>`
    position: relative;
    display: inline-block;
    width: 3.5rem;
    height: 2rem;

    & input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${({ offbackgroundcolour: offbackgroundcolour }) =>
            offbackgroundcolour ||
            colourScheme.primaryDark}; // Use custom color if provided
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 1.5rem;
        width: 1.5rem;
        left: 0.25rem;
        bottom: 0.25rem;
        background-color: ${colourScheme.white};
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }

    input:checked + .slider {
        background-color: ${colourScheme.secondary};
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(1.5rem);
        -ms-transform: translateX(1.5rem);
        transform: translateX(1.5rem);
    }

    .slider.round {
        border-radius: 1rem;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    input:disabled + .slider {
        filter: brightness(0.4);
    }
`;
